<app-page-layout>
  <app-queue-stats
    [showDetails]="true"
    [compact]="false"
    appearance="dashboard"
  />
</app-page-layout>
